var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.696 59.3182C194.989 63.5708 185.221 70.8608 180.923 74.207C176.884 77.7536 163.378 85.2612 173.419 89.7755C187.664 94.9056 203.665 96.1984 215.306 106.893C251.507 140.349 229.337 184.766 191.815 205.306C174.144 214.972 159.941 211.571 150.778 212.218C130.712 213.635 129.424 213.635 114.375 213.635C92.6366 213.635 88.1264 214.578 76.5525 212.218C68.5844 210.619 61.0663 207.177 54.528 202.344C47.2624 196.899 44.2788 191.525 40.721 183.558C31.5103 162.877 31.4653 142.449 41.2175 122.242C48.5446 107.031 54.528 103.88 73.4067 94.2816C85.9479 90.1084 95.0649 87.3247 105.943 86.8054C111.026 86.0537 114.47 83.9637 112.007 78.5692C109.273 70.0888 102.293 63.209 101.513 54.1004C100.061 46.5716 106.649 33.7451 115.396 40.0942C120.578 42.365 128.059 66.5618 133.861 55.5C137.505 48.7923 139.631 26.2208 150.778 32.0443C154.931 34.1954 157.599 40.2231 155.765 45.707C154.2 50.3384 154.651 55.692 154.597 60.6947C155.016 65.4784 163.33 61.3223 166.499 60.9267C166.648 60.8907 166.748 60.8668 166.897 60.8308C168.378 60.4217 180.529 57.5472 186.696 59.3182Z",
    fill: "url(#paint0_radial_336_53308)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.161 39.9435C155.532 36.4709 153.485 33.4451 150.778 32.0487C150.543 31.9477 150.358 31.8348 150.123 31.7338C150.105 33.839 150.161 36.0314 150.144 38.1366C150.381 40.863 153.188 40.7122 156.161 39.9435Z",
    fill: "url(#paint1_linear_336_53308)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.696 59.3211C180.084 57.4475 178.904 70.8624 172.294 71.6142C172.318 71.7134 166.736 60.82 166.711 60.9313C166.5 60.9296 166.251 60.9895 165.952 61.0614C164.754 63.2933 165.121 65.4635 168.967 67.2158C173.867 68.9766 179.032 70.3061 184.098 71.6596C188.523 67.9675 193.247 62.6804 186.696 59.3211Z",
    fill: "url(#paint2_linear_336_53308)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.602 55.9959C106.403 52.3453 104.495 49.0234 102.574 45.6519C101.458 48.4417 101.01 51.596 101.51 54.1017C101.805 57.4973 102.97 60.5779 104.484 63.5747C107.796 62.462 109.527 60.2591 107.602 55.9959Z",
    fill: "url(#paint3_linear_336_53308)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M170.076 158.284C155.609 172.273 152.659 177.711 133.961 182.688C124.755 185.115 115.325 181.609 106.641 185.539C95.9245 190.431 83.7099 191.956 72.136 189.596C64.1679 187.996 56.6498 184.555 50.1115 179.722C42.7962 174.289 39.8245 168.964 36.3165 160.985C35.6581 159.568 35.0872 158.078 34.566 156.575C35.0578 166.016 37.0285 175.258 40.7199 183.56C44.2777 191.527 47.2614 196.901 54.5149 202.297C61.0035 207.142 68.5714 210.571 76.5395 212.171C88.1133 214.53 100.278 213.018 111.044 208.114C119.729 204.184 128.967 203.849 138.364 205.262C156.873 207.999 174.131 214.925 191.802 205.259C222.727 188.355 243.201 155.219 229.201 125.397C189.86 137.762 186.72 142.195 170.076 158.284Z",
    fill: "url(#paint4_linear_336_53308)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M154.076 97.5359C160.892 95.8941 167.108 93.2939 172.561 89.9321C164.034 85.3681 176.88 78.1772 180.843 74.7539C185.191 71.3956 194.909 64.1176 186.616 59.8651C180.003 57.9914 166.606 61.376 166.63 61.4753C163.624 61.674 154.861 66.1485 154.479 61.3032C154.472 56.2628 154.082 50.9469 155.648 46.3154C157.481 40.8316 154.863 34.7919 150.66 32.6528C139.612 26.8053 137.437 49.3888 133.793 56.0965C127.991 67.1583 120.498 42.9119 115.328 40.6907C106.581 34.3416 99.9934 47.1681 101.445 54.6969C102.263 63.7439 109.205 70.6853 111.939 79.1657C114.402 84.5602 110.958 86.6502 105.875 87.4018C105.304 87.4344 104.732 87.467 104.149 87.4499C116.066 97.7626 134.872 102.162 154.076 97.5359Z",
    fill: "url(#paint5_radial_336_53308)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M135.948 186.988C114.057 192.261 95.5553 201.969 83.781 213.157C93.0856 213.752 102.509 212.007 110.995 208.125C119.68 204.195 128.918 203.86 138.315 205.273C156.824 208.01 174.082 214.936 191.752 205.27C197.987 201.877 203.744 197.812 208.908 193.259C193.803 182.821 165.8 179.797 135.948 186.988Z",
    fill: "url(#paint6_radial_336_53308)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.027 90.1895C124.066 94.0487 132.648 96.4459 142.483 95.9678C152.157 95.4759 160.339 92.2971 164.035 88.2029C159.996 84.3437 151.414 81.9465 141.579 82.4247C131.943 82.8549 123.761 86.0337 120.027 90.1895Z",
    fill: "url(#paint7_linear_336_53308)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M187.777 148.295C188.449 155.433 184.957 160.371 182.058 159.704C179.109 159.049 177.46 154.404 176.847 149.037C176.346 143.695 176.812 138.436 179.663 137.381C182.453 136.289 187.104 141.156 187.777 148.295Z",
    fill: "#3E335D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M139.706 153.098C139.907 160.246 136.106 164.995 133.209 164.117C130.262 163.252 128.961 158.523 128.708 153.121C128.567 147.745 129.368 142.563 132.317 141.695C135.205 140.789 139.506 145.951 139.706 153.098Z",
    fill: "#3E335D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M159.627 156.442C159.898 156.691 160.358 156.633 160.546 156.325C160.948 155.808 161.349 155.291 161.689 154.737C161.941 154.256 161.959 153.674 162.261 153.181C162.777 152.269 163.663 151.793 164.577 152.308C165.182 152.635 165.659 153.518 165.827 154.213C165.933 154.87 165.592 155.635 165.399 156.364C164.392 159.601 161.657 161.572 159.042 160.994C156.428 160.416 154.185 157.017 154.582 154.085C154.675 153.38 155.241 152.456 155.864 152.201C156.923 151.788 157.499 152.647 157.876 153.554C158.704 155.456 158.838 155.791 159.627 156.442Z",
    fill: "#3E335D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M103.9 83.1485C109.488 81.435 121.801 82.9334 121.813 82.983C124.482 82.9178 132.828 85.4246 132.545 82.0786C131.829 78.6796 131.463 74.9862 129.465 71.9484C127.062 68.3253 128.613 64.0653 131.991 62.3587C141.029 57.713 146.028 72.9486 150.175 77.2544C156.805 84.4286 160.137 67.5016 164.423 65.6289C171.303 60.7678 178.843 69.0886 178.625 74.2882C179.132 80.5215 173.938 85.6067 172.646 91.5902C172.43 92.2201 172.301 92.7763 172.309 93.247C165.292 98.1937 155.158 101.79 143.58 102.898C135.803 103.616 128.421 103.136 121.954 101.647C125.048 98.3282 114.614 94.8015 111.054 92.9276C106.777 90.9118 97.1931 86.5498 103.9 83.1485Z",
    fill: "url(#paint8_radial_336_53308)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M148.535 71.7715C147.237 69.6676 145.841 67.3771 144.23 65.5059C145.712 67.9333 146.997 70.1981 148.252 71.4719C148.338 71.6088 148.411 71.6961 148.535 71.7715Z",
    fill: "url(#paint9_radial_336_53308)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M170.38 87.4585C163.365 92.4061 153.232 96.0016 141.654 97.1064C133.878 97.8218 127.17 98.385 124.078 101.705C132.467 109.62 143.868 108.873 151.595 108.17C161.321 107.247 165.72 105.19 176.983 99.956C186.452 95.5742 189.792 96.9779 191.667 95.3702C191.658 94.8992 174.982 91.029 175.198 90.3988C176.487 84.4117 170.36 86.9379 170.38 87.4585Z",
    fill: "url(#paint10_linear_336_53308)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_336_53308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.8177 72.2622) rotate(-13.543) scale(175.395 175.008)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00555556,
    stopColor: "#5295FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5389,
    stopColor: "#3F7FFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3ED2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_336_53308",
    x1: 192.665,
    y1: 222.02,
    x2: 165.944,
    y2: 97.8933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00555556,
    stopColor: "#2556BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F7FFD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_336_53308",
    x1: 210.511,
    y1: 215.477,
    x2: 184.264,
    y2: 93.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00555556,
    stopColor: "#2556BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F7FFD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_336_53308",
    x1: 142.97,
    y1: 232.715,
    x2: 116.248,
    y2: 108.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00555556,
    stopColor: "#2556BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F7FFD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_336_53308",
    x1: 181.309,
    y1: 236.086,
    x2: 120.314,
    y2: 128.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00555556,
    stopColor: "#2556BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F7FFD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_336_53308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(141.001 10.8801) rotate(-13.543) scale(86.6615 86.4705)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00555556,
    stopColor: "#5295FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5389,
    stopColor: "#3F7FFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E64D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_336_53308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(233.007 201.682) rotate(-13.543) scale(96.3375 96.1252)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E53BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#2C61CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_336_53308",
    x1: 142.631,
    y1: 96.4451,
    x2: 141.011,
    y2: 76.4785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00555556,
    stopColor: "#2556BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A4FA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_336_53308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.7137 47.77) rotate(-173.668) scale(207.848 195.476)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00555556,
    stopColor: "#5295FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5389,
    stopColor: "#3F7FFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3ED2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_336_53308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.782 81.5963) rotate(-13.5324) scale(76.6185 76.512)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5389,
    stopColor: "#3F7FFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3ED2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_336_53308",
    x1: 85.3237,
    y1: 104.358,
    x2: 179.778,
    y2: 95.6316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5389,
    stopColor: "#346AE0",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#285DC7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading11);
export default __webpack_public_path__ + "static/media/loading_11.36f924ee1f5f08e25053a7dfaadc85ea.svg";
export { ForwardRef as ReactComponent };